var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('CargaTable',{ref:"cargaTable",attrs:{"params":_vm.params,"columnsConfig":_vm.columnsConfigCarga}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }